import React from "react";
import { Link } from "react-router-dom";
import "../Css/about.css";
import OurApproach from "../Img/About-us/Our-Approach.jpg";
import OurApproachimg from "../Img/About-us/Our-Approach2.jpg";
import { MdArrowRightAlt } from "react-icons/md";
import Believe from "../Img/About-us/Believe.gif";
import Resilient from "../Img/About-us/Resilient.gif";
import Team from "../Img/About-us//team.gif";
import BannerImg from "../Img/Final-images/About-banner.jpeg";

function About() {
  return (
    <>
      {/* Banner */}
      <section className="about-banne text-center mobile-view">
        <div>
          <img src={BannerImg} className="w-100" />
        </div>
        <div className="container mobile-view-none">
          <div className="breadcrumb-container" aria-label="Breadcrumb">
            <ul className="breadcrumbs">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li aria-current="page">About Affinity</li>
            </ul>
          </div>
          {/*
          <h1 className="banner-heading">Affinity</h1> */}
        </div>
      </section>

      {/* Who We Are */}
      <section className="pt-5">
        <div className="container">
          <h3 className="sub-heading text-center mb-4">Who We Are</h3>
          <p>
            Affinity Childrens Services Ltd was established in 2022. It shares
            its central support services, working in collaboration, each
            providing social care solutions in their own specific areas.
          </p>
          <p>
            Affinity Childrens Services Ltd provides therapeutic care to
            children and young people in our homes across the West Midlands. We
            offer a holistic approach to care that covers a range of therapeutic
            models and incorporates a full plan for health, education and care.
            Our aim is to ensure that all our children, young people are given
            the support and opportunities to achieve successful outcomes and
            thrive as members of their communities.
          </p>
        </div>
      </section>

      <section className="our-approach py-5">
        <div className="container">
          {/* Row 1 */}
          <div className="row align-items-center g-4 mb-4">
            <div className="col-12 col-md-6">
              <h3 className="mb-4 sub-heading text-center text-md-start">
                About Affinity Children's Services
              </h3>
              <p>
                Affinity Childrens Services Limited operates a small number of
                Ofsted regulated residential children’s homes across
                Staffordshire and surrounding areas. We provide care for
                children and young people aged 7–17 who require stable,
                nurturing environments following experiences of trauma, loss, or
                disrupted attachments.
              </p>
              <p>
                Each home has its own Registered Manager and Statement of
                Purpose, but all homes share the same organizational ethos,
                safeguarding procedures, and quality standards. Our teams are
                committed to reflective practice, continuous improvement, and
                delivering care that meets and exceeds regulatory expectations.
              </p>
              <p>
                We believe that children flourish when they feel safe,
                understood, and supported by adults who genuinely care about
                their wellbeing.
              </p>
            </div>

            <div className="col-12 col-md-6 text-center">
              <img
                src={OurApproach}
                alt="Our Approach"
                className="img-fluid rounded about-img"
              />
            </div>
          </div>

          {/* Row 2 
          <div className="row align-items-center g-4">
            <div className="col-12 col-md-6 order-2 order-md-2">
              <p>
                Each home has its own Registered Manager and Statement of
                Purpose, but all homes share the same organizational ethos,
                safeguarding procedures, and quality standards. Our teams are
                committed to reflective practice, continuous improvement, and
                delivering care that meets and exceeds regulatory expectations.
              </p>
            </div>

            <div className="col-12 col-md-6 order-1 order-md-1 text-center">
              <img
                src={OurApproachimg}
                alt="Our Care Environment"
                className="img-fluid rounded about-img"
              />
            </div>
          </div>*/}
        </div>
      </section>

      {/* Our Mission
      <section className="our-mission py-5">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-12 col-md-7">
              <h3 className="sub-heading text-white mb-3">Our Mission</h3>
              <p className="text-white mb-0">
                Our mission at Affinity Childrens Services Ltd is to provide a
                safe, nurturing, and empowering environment for children and
                young people. We are dedicated to supporting their emotional,
                social, and academic growth while addressing individual needs
                with compassion and understanding. We strive to promote each
                child's well-being and personal development through
                trauma-informed care, fostering positive relationships, and
                encouraging ambitions for their future. We are committed to
                providing personalized care that respects and values each
                child's unique identity, culture, and background. Collaboration
                with families, professionals, and the wider community ensures
                holistic support for the children in our care. Through high
                standards of care, a skilled team, and a commitment to ongoing
                learning, we aim to help every child achieve their full
                potential and prepare for a brighter, independent future.
              </p>
            </div>

            {/* Mission Image (optional) 
            <div className="col-12 col-md-5 text-center">
              <img
                src={OurApproach}
                alt="Our Mission"
                className="img-fluid rounded about-img mission-img"
              />
            </div>
          </div>
        </div>
      </section> */}

      {/* Our Values
      <section className="Our-value py-5">
        <div className="container">
          <h3 className="sub-heading text-center text-md-start mb-3">
            Our Values
          </h3>

          <p className="mb-4">
            Affinity Childrens Services Ltd values creating a safe and
            supportive environment for children, focusing on personalized care
            that respects each child’s identity, cultural background, and
            preferences. Emphasis is placed on promoting educational
            achievement, fostering meaningful relationships, and encouraging
            ambition. The home employs trauma-informed therapeutic approaches to
            address emotional and behavioral challenges, while maintaining a
            commitment to equality, anti-discrimination, and holistic
            development. Affinity Childrens Services Ltd also prioritizes
            community engagement, healthy living, and professional excellence,
            ensuring a nurturing space where children can thrive and reach their
            full potential.
          </p>

          <div className="row g-4">
            {/* Card 1 
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card border-0 shadow-lg h-100 about-value-card">
                <div className="card-body">
                  <div className="row g-3 align-items-start">
                    <div className="col-3 col-md-2 text-center">
                      <div className="about-icon-wrap">
                        <img
                          src={Believe}
                          alt="Believe"
                          className="about-icon"
                        />
                      </div>
                    </div>

                    <div className="col-9 col-md-10">
                      <strong className="fw-bold d-block mb-2">
                        We Believe Everyone Matters
                      </strong>

                      <ul className="list-unstyled mb-0">
                        <li className="mb-2 d-flex">
                          <span className="me-2 text-success fs-4">
                            <MdArrowRightAlt />
                          </span>
                          We see everyone as an individual, seek to understand
                          their needs and aspirations, and value their
                          differences.
                        </li>

                        <li className="mb-2 d-flex">
                          <span className="me-2 text-success fs-4">
                            <MdArrowRightAlt />
                          </span>
                          We encourage everyone to have a voice.
                        </li>

                        <li className="d-flex">
                          <span className="me-2 text-success fs-4">
                            <MdArrowRightAlt />
                          </span>
                          We actively listen and respect each other’s
                          contributions.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2 
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card border-0 shadow-lg h-100 about-value-card">
                <div className="card-body">
                  <div className="row g-3 align-items-start">
                    <div className="col-3 col-md-2 text-center">
                      <div className="about-icon-wrap">
                        <img
                          src={Resilient}
                          alt="Resilient"
                          className="about-icon"
                        />
                      </div>
                    </div>

                    <div className="col-9 col-md-10">
                      <strong className="fw-bold d-block mb-2">
                        We Are Resilient
                      </strong>

                      <ul className="list-unstyled mb-0">
                        <li className="mb-2 d-flex">
                          <span className="me-2 text-success fs-4">
                            <MdArrowRightAlt />
                          </span>
                          We view change as a challenge and an opportunity
                        </li>

                        <li className="mb-2 d-flex">
                          <span className="me-2 text-success fs-4">
                            <MdArrowRightAlt />
                          </span>
                          We can handle stress and unpleasant feelings and
                          engage with others for support
                        </li>

                        <li className="d-flex">
                          <span className="me-2 text-success fs-4">
                            <MdArrowRightAlt />
                          </span>
                          Give our best efforts, no matter what and never give
                          up
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3 
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card border-0 shadow-lg h-100 about-value-card">
                <div className="card-body">
                  <div className="row g-3 align-items-start">
                    <div className="col-3 col-md-2 text-center">
                      <div className="about-icon-wrap">
                        <img src={Team} alt="Team" className="about-icon" />
                      </div>
                    </div>

                    <div className="col-9 col-md-10">
                      <strong className="fw-bold d-block mb-2">
                        We Work As A Team
                      </strong>

                      <ul className="list-unstyled mb-0">
                        <li className="mb-2 d-flex">
                          <span className="me-2 text-success fs-4">
                            <MdArrowRightAlt />
                          </span>
                          We work together to achieve our goals
                        </li>

                        <li className="mb-2 d-flex">
                          <span className="me-2 text-success fs-4">
                            <MdArrowRightAlt />
                          </span>
                          We are understanding and are interested in how each
                          other work
                        </li>

                        <li className="d-flex">
                          <span className="me-2 text-success fs-4">
                            <MdArrowRightAlt />
                          </span>
                          We share our time and our knowledge to innovate each
                          other
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Cards 
          </div>
        </div>
      </section> */}
    </>
  );
}

export default About;
